export interface IMultiFacility {
  manageFacilityHint: string;
  setLevelHint: string;
  facilityTrees: facilityNodeObject[];
}

export class facilityNodeObject {
  facilityNodes: facilityLevelObject[];
  facilityCount?: string;
}

export class facilityLevelObject {
  facilityId: string;
  facilityName?: string;
  id?: string;
  level: string;
  parentId?: string;
  path?: string;

  // for testing purpose
  // rootFacilityId: string;

  constructor(_facilityId: string, _level: string, _facilityName?: string, _parentId?: string | null, _path?: string) {
    this.facilityId = _facilityId;
    this.level = _level;
    this.facilityName = _facilityName;
    if (_parentId) this.parentId = _parentId;
    else delete this['parentId'];
    this.path = _path;
  }

  // get rootFacility(): string {
  //   // return this.path?.split('.')?[0] || this.facilityId
  // }
}

export class FacilityTreesModel {
  facilityTrees: facilityNodesModel[] = [];
  constructor(_facilityTrees: facilityNodesModel[]) {
    this.facilityTrees = _facilityTrees;
  }
}

export class facilityNodesModel {
  facilityNodes: facilityLevelObject[] = [];
  facilityCount: number = 1;
  constructor(_facilityNodes: facilityLevelObject[], _facilityCount: number) {
    this.facilityNodes = _facilityNodes;
    this.facilityCount = _facilityCount;
  }
}

export class MultiFacilityModel {
  facilityId: string;
  facilityName: string;
  id?: string;
  level: string;
  parentId?: string;
  path: string;
  children: MultiFacilityModel[];
  showChildren?: boolean;
  isAdmin?: boolean;
  soleManager?: string;
  isLFODSupportedFacility?: boolean;

  // for multi site top bar
  isSelected?: boolean;
  isDisabledSelectedFacility?:boolean;
  isExpanded?: boolean;
  isEnabled?: boolean;

  constructor(
    _facilityId: string = '',
    _facilityName: string = '',
    _level: string = '',
    _path: string = '',
    _children: MultiFacilityModel[] = [],
    _parentId?: string,
    _showChildren?: boolean,
    _isAdmin?: boolean,
    _soleManager?: string,
    _isLFODSupportedFacility?: boolean,
    _isSelected?: boolean,
    _isExpanded?: boolean,
  ) {
    this.facilityId = _facilityId;
    this.facilityName = _facilityName;
    this.level = _level;
    this.path = _path;
    this.children = _children;
    this.parentId = _parentId;
    this.showChildren = _showChildren;
    this.isAdmin = _isAdmin;
    this.soleManager = _soleManager;
    this.isLFODSupportedFacility = _isLFODSupportedFacility || false;
    this.isSelected = _isSelected || false;
    this.isExpanded = _isExpanded || false;
  }
}

export class MultiFacilitySetLevelOption {
  facilityId: string;
  facilityName: string;
  isSelected: boolean;
}

export class SelectWithCheckboxRadioOption {
  id: string;
  label: string;
  checked?: boolean;
  constructor(_id: string, _label: string, _checked?: boolean) {
    this.id = _id;
    this.label = _label;
    this.checked = _checked || false;
  }
}

export interface SelectWithCheckboxRadioValue {
  selected: SelectWithCheckboxRadioOption[];
  isMultiple: boolean;
}

export class PayloadSetLevelFacilityTrees {
  facilityNodes: PayloadSetLevelFacilityTreesFacilityNodes[] = [];
  constructor(_facilityNodes: PayloadSetLevelFacilityTreesFacilityNodes[]) {
    this.facilityNodes = _facilityNodes;
  }
}

export class PayloadSetLevelFacilityTreesFacilityNodes {
  facilityId: string;
  parentId: string | null;
  path?: string | null;
  level: string;
  constructor(_facilityId: string, _parentId: string | null, _path?: string | null, _level: string = '1') {
    this.facilityId = _facilityId;
    this.parentId = _parentId;
    this.path = _path;
    this.level = _level;
  }
}

// export class InviteFacilityRequest {
//   requesterEmail: string;
//   requesterFirstname: string;
//   requesterLastName: string;
//   requesterId: string;
//   requestedFacilityName: string;
//   requestedFacilityId: string;
//   senderEmail: string;
//   createdAt: Date;
//   updatedAt: Date;
// }

/**
 * Invite Facility
 */
export class InviteFacilityModel {
  email: string;
  requestedFacilityId: string;
  emailErrorCodes?: string[];
  facilityErrorCodes?: string[];
  inviteFacilityRequestExistsWith?: string;

  constructor(email: string, requestedFacilityId: string, emailErrorCodes?: string[], facilityErrorCodes?: string[]) {
    this.email = email;
    this.requestedFacilityId = requestedFacilityId;
    this.emailErrorCodes = emailErrorCodes;
    this.facilityErrorCodes = facilityErrorCodes;
  }
}

export class ResponseInviteFacilityModel {
  status: number;
  messages: string;
  invalidParams?: InviteFacilityModel[];

  constructor(status: number, messages: string, invalidParams: InviteFacilityModel[]) {
    this.status = status;
    this.messages = messages;
    this.invalidParams = invalidParams;
  }
}

export class RequestInviteFacilityModel {
  inviteFacilityVOList: InviteFacilityModel[];

  constructor(inviteFacilityVOList: InviteFacilityModel[]) {
    this.inviteFacilityVOList = inviteFacilityVOList;
  }
}

/**
 * Pending and Manage Facility List
 */
export class InvitedFacility {
  approverEmail: string;
  approverFirstName: string;
  approverLastName: string;
  approverUserId: string;
  requestedFacilityId: string;
  requestedFacilityName: string;
  senderEmail: string;
  senderFirstName: string;
  senderLastName: string;
  senderUserId: string;
  createdAt: string;
  updatedAt: string;
  showMore?:boolean;
}

export class InvitedFacilityResponse {
  inviteFacilityRequestWrapper: InvitedFacility[];
}

export class AcceptRejectRequestPayload {
  senderId:string;
  requestedFacilityId: string;
  status: string;
}
